if (!customElements.get('component-video')) {
  class Video extends HTMLElement {
    constructor() {
      super();

      this.playButton = this.querySelector('[data-video-play-button]');
      this.videoWrapper = this.querySelector('[data-video-wrapper]');

      if (this.playButton) {
        this.playButton.addEventListener('click', this.playVideo.bind(this));
      }
    }

    playVideo() {
      this.stopVideos();

      const videoIframe = this.querySelector('iframe');
      const videoElement = this.querySelector('video');

      if (videoIframe) {
        const videoIframeSrc = videoIframe.getAttribute('data-src');

        if (videoIframeSrc.indexOf('youtube') >= 0) {
          videoIframe.setAttribute('src',`${videoIframeSrc}?autoplay=1&modestbranding=1&autohide=1`);
        } else {
          videoIframe.setAttribute('src',`${videoIframeSrc}?autoplay=1`);
        }
      } else if (videoElement) {
        videoElement.play();
        videoElement.setAttribute('controls', '');
      }

      this.playButton.classList.add('d-none');
      this.videoWrapper.classList.remove('d-none');
    }

    stopVideos() {
      const videos = document.querySelectorAll('component-video');

      if (!videos.length) { return; }

      videos.forEach((video) => {
        const playButton = video.querySelector('[data-video-play-button]');
        const videoWrapper = video.querySelector('[data-video-wrapper]');

        if (videoWrapper.classList.contains('d-none')) { return; }

        playButton.classList.remove('d-none');
        videoWrapper.classList.add('d-none');

        const videoIframe = videoWrapper.querySelector('iframe');
        const videoElement = videoWrapper.querySelector('video');

        if (videoIframe) {
          const videoIframeSrc = videoIframe.getAttribute('data-src');

          videoIframe.setAttribute('src',`${videoIframeSrc}?autoplay=0`);
        } else if (videoElement) {
          videoElement.pause();
          videoElement.removeAttribute('controls');
        }
      });
    }
  }

  customElements.define('component-video', Video);
}